const FIX_ROUTE_MAP: Record<string, (projectId: string) => string> = {
  customer_context: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=overview`,
  project_context: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=overview`,
  pre_discovery_answers: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=preDiscovery`,
  meeting_evidence: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=meetings`,
  document_evidence: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=discovery`,
  notes_present: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=discovery`,
  meetings_captured: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=meetings`,
  requirements_linked: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=requirements`,
  work_items_planned: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=workplan`,
  spec_sections: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=specs`,
  readiness_review: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=coverage`,
  project_brief: (projectId) => `/projects/${encodeURIComponent(projectId)}?tab=brief`,
};

export function resolveReadinessFixRoute(projectId: string, ruleId: string): string | null {
  const resolver = FIX_ROUTE_MAP[ruleId];
  return resolver ? resolver(projectId) : `/projects/${encodeURIComponent(projectId)}?tab=coverage`;
}

export function listKnownReadinessFixRoutes(): Array<{ ruleId: string; href: string }> {
  return Object.entries(FIX_ROUTE_MAP).map(([ruleId, resolver]) => ({ ruleId, href: resolver("{projectId}") }));
}
